import { Directory, Encoding, Filesystem } from '@capacitor/filesystem';
import { Share } from '@capacitor/share';

import { isCapacitorNative } from '@/core/utils/capacitor.utils';

/**
 * Download or share a vCard string.
 * Native: write to Cache + Share sheet; browser: Blob + anchor download.
 */
export async function downloadVcfFile(
  vcf: string,
  filename: string,
): Promise<void> {
  if (isCapacitorNative()) {
    try {
      const writeResult = await Filesystem.writeFile({
        path: filename,
        data: vcf,
        directory: Directory.Cache,
        encoding: Encoding.UTF8,
      });
      await Share.share({
        title: filename,
        text: filename,
        url: writeResult.uri,
      });
      return;
    } catch (error) {
      console.error(
        'Native vCard export failed, using browser fallback',
        error,
      );
    }
  }

  const blob = new Blob([vcf], { type: 'text/vcard;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}
